import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APIService } from '@core/services/api.service';
import { ApiResponse, EmptyApiResponse } from '@core/models/api-response.model';
import { FileResponse } from '@core/models/file-response.model';
import { CompanyDetails, RequestCreateCompany } from '../models/company-detail.model';
import { AccountInfo, AccountVerified, BankAccountDetail } from '../models/account-info.model';



@Injectable({
  providedIn: 'root'
})
export class CompanyDetailsService {


  constructor(private readonly apiService: APIService) { }


  getCompanyDetails(): Observable<CompanyDetails> {
    return this.apiService.get<CompanyDetails>('Company/GetCompanyDetailsByCompanyId');
  }

  createCompanyDetails(CompanyDetails: RequestCreateCompany): Observable<ApiResponse<CompanyDetails>> {
    return this.apiService.postWithAllResponse<CompanyDetails>('Company/CreateCompanyDetails', CompanyDetails);
  }

  imageUplaod(data: FormData): Observable<FileResponse> {
    return this.apiService.post<FileResponse>('User/ImageUpload', data);
  }
  editCompanyDetails(data: any): Observable<any> {
    return this.apiService.post<CompanyDetails>('Company/EditCompanyProfileDetails', data);
  }

  addBankAccountDetails(details: BankAccountDetail): Observable<AccountInfo> {
    return this.apiService.post<AccountInfo>('Stripe/AddBankAccountDetails', details);
  }

  getConnectedAccountDetails(): Observable<AccountVerified> {
    return this.apiService.get<AccountVerified>('Stripe/GetConnectedAccountDetails');
  }

  deleteExternalBankAccount(): Observable<string> {
    return this.apiService.delete<EmptyApiResponse>('Stripe/deleteExternalBankAccount')
      .pipe(
        map(response => {
          return response.message;
        }));
  }
  
}